/* istanbul ignore file */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useLayoutEffect } from 'react';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { useApi } from '../../../hooks/use-api';
import { LookupAutocomplete } from '../components/lookup-autocomplete';
import { ICitizenLookup, ICitizenLookupProps } from './interfaces';
import { formatCitizenValue, renderCitizen } from './formatters';
import { useFetch } from './useFetch';
import { ReadonlyInput } from '../../readonly-input/readonly-input';
import { GetCitizenLookupByIdResponse } from '../../../api-service/clients';

export function CitizenLookup(props: ICitizenLookupProps) {
  const { onChange, value, fetchMinimumInputLength = 2, label = 'Borger', placeholder = 'Fremsøg borger', readOnly, ...rest } = props;

  const [selectedValue, setSelectedValue] = useState<ICitizenLookup>({} as ICitizenLookup);
  const [searchValue, setSearchValue] = useState('');

  function handleOnChange(selected: ICitizenLookup) {
    onChange?.(selected);
  }

  const lookupsClient = moduleClientFactory.createLookupCitizenClient();
  const lookupSingleEntityApi = useApi((cancelToken, citizenId) => lookupsClient.getCitizenLookupById({ citizenId }, cancelToken), {} as GetCitizenLookupByIdResponse);

  useLayoutEffect(() => {
    if (!value) {
      setSelectedValue({} as ICitizenLookup);
      return;
    }
    async function getSingle() {
      const response = await lookupSingleEntityApi.invoke(value);
      if (response.result.citizen) {
        setSelectedValue(response.result.citizen);
      }
    }
    getSingle();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const { data, loading } = useFetch({ input: searchValue, fetchMinimumInputLength });

  return readOnly ? (
    <ReadonlyInput label={label} value={formatCitizenValue(selectedValue)} />
  ) : (
    <LookupAutocomplete<ICitizenLookup>
      {...rest}
      label={label}
      placeholder={placeholder}
      isOptionEqualToValue={(option, val) => option?.citizenId === val?.citizenId}
      getOptionLabel={formatCitizenValue}
      renderOption={renderCitizen}
      onChange={handleOnChange as never}
      value={selectedValue}
      onSearchValueChange={setSearchValue}
      data={data}
      isLoading={loading}
    />
  );
}
